const Constant = {
    IN_PROGRESS: 'In progress',
    ACCEPTED: 'Accepted',
    REJECTED: 'Rejected',
    SUBMITTED: 'Submitted',
    REQUESTED: 'Requested',
    ADMIN: 'Admin',
    SUPER_ADMIN: 'Super Admin',
    AGENT_ADMIN: 'Agent Admin',
    CLIENT_ADMIN: 'Client Admin',
    AGENT_USER: 'Agent User',
    CLIENT_USER: 'Client User',
    DC_SUPER_ADMIN: 'DC-SuperAdmin',
    WIDTH: 162,
    LINK: 'link',
    FILE: 'file',
    SUBMIT_COLOR: '#FEC83D',
    ACCEPT_COLOR: '#3F9F47',
    REJECT_COLOR: '#EF4640',
    DATE_FORMAT: 'YYYY-MM-DD'
}
export default Constant